import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=aa12fd26&scoped=true&"
import script from "./ListDocuments.vue?vue&type=script&lang=ts&"
export * from "./ListDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa12fd26",
  null
  
)

export default component.exports